/* eslint-disable no-lonely-if */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Dialog,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  tableCellClasses,
  Paper,
  Grid,
  Stack,
  styled,
  MenuItem,
  Chip,
  DialogActions,
  DialogTitle,
  DialogContent,
  Container,
  Card,
  CardContent,
  Box,
} from '@mui/material';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { LocationOn } from '@mui/icons-material';
import EditIcon from '@mui/icons-material/Edit';
import CancelIcon from '@mui/icons-material/Cancel';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import axios from '../../../utils/axios';
import sea2 from '../../../media/Images/sea2.jpg';
import seaicon from '../../../media/Images/seaicon.png';
import airicon1 from '../../../media/Images/air-icon-1.png';
import airicon2 from '../../../media/Images/air-icon-3.png';
import air from '../../../media/Images/air3.jpg';
import air2 from '../../../media/Images/2.jpg';
import '../../stylemod.css';
import UIContext from '../../../context/UIContext';
import NoResultsFound from '../../../components/NoResultsFound';

const StyledTableCell = styled(TableCell)({
  color: 'white',
  fontWeight: '600',
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#257180',
  },
  whiteSpace: 'nowrap',
});

// const shipMentTypesforIN = [
//   { label: 'Air Cargo - Srilanka', value: 'ACSL' },
//   { label: 'Air Cargo - India', value: 'ACI' },
// ];

// const shipMentTypesforUK = [
//   { label: 'Air Cargo - Srilanka', value: 'ACSL' },
//   { label: 'Air Cargo - India', value: 'ACI' },
//   { label: 'Sea Cargo - Srilanka', value: 'SCSL' },
// ];

const shipMentTypesforIN = [
  { label: 'Air Cargo Srilanka', value: 'ACSL', image: air, icon: airicon2 },
  // { label: 'Air Cargo India', value: 'ACI', image: air2, icon: airicon1 },
];

const shipMentTypesforUK = [
  { label: 'Air Cargo Srilanka', value: 'ACSL', image: air, icon: airicon2 },
  { label: 'Air Cargo India', value: 'ACI', image: air2, icon: airicon1 },
  { label: 'Sea Cargo Srilanka', value: 'SCSL', image: sea2, icon: seaicon },
];

const shipMentTypesforSL = [
  { label: 'Air Cargo - OverAll', value: 'ACO', image: air, icon: airicon2 },
];

const statusOptions = [
  { label: 'All', value: 'All' },
  { label: 'Pending', value: 'Pending' },
  { label: 'Approved', value: 'Approved' },
  { label: 'Cancelled', value: 'Cancelled' },
  { label: 'Cancelled Request', value: 'Cancelled Request' },
  { label: 'Booking Confirmed', value: 'Booking Confirmed' },
  { label: 'Bill Raised', value: 'Bill Raised' },
  { label: 'Payment Received', value: 'Payment Received' },
  { label: 'Part. Payment', value: 'Part. Payment' },
];

const typeOptions = [
  { label: 'Air-Cargo', value: 'courier' },
  { label: 'Sea-Cargo', value: 'cargo' },
];

const filteredOptions = typeOptions.filter((option) =>
  sessionStorage.getItem('Origin') === 'IN' ? option.value === 'courier' : true
);

const ManageBooking = () => {
  const navigate = useNavigate();
  const [getDataForView, setGetDataForView] = useState([]);
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [rowDeleteID, setRowDeleteID] = useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteRowID, setDeleteRowID] = useState(null);
  const [openShipmentPopup, setOpenShipmentPopup] = useState(false);
  const [selectedShipment, setSelectedShipment] = useState('');
    const [viewDraft, setViewDraft] = useState(false);
  const [filterInputs, setFilterInputs] = useState({
    fromDate: moment().startOf('month').format('YYYY-MM-DD'),
    toDate: moment().format('YYYY-MM-DD'),
    status: 'All',
    type: sessionStorage.getItem('Origin') === 'UK' ? 'cargo' : 'courier',
  });

  const origin = sessionStorage.getItem('Origin') || 'IN'; // Default to IN if not set
  const shipmentTypes = origin === 'IN' ? shipMentTypesforIN 
                                        :  (origin === 'UK') ? shipMentTypesforUK
                                        : shipMentTypesforSL;
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');
  const [isComplaintDialogOpen, setComplaintDialogOpenState] = useState(false);
  const [complaintDetail, setComplaintDetail] = useState({
    courierCargoId: '',
    shipmentType: '',
    userType: 'Customer',
    complaintId: '',
    bookingOrderId: 0,
    Register: 'N',
  });

  const closeComplaintDialog = () => {
    setComplaintDialogOpenState(false);
  };

  // Handle input change
  const handleReasonChange = (event) => {
    setReason(event.target.value);
    setError(''); // Clear error when user starts typing
  };

  const handleConfirmDelete = () => {
    if (!reason.trim()) {
      setError('Please provide a reason for cancellation.');
      return;
    }
    if (rowDeleteID !== null) {
      cancelOrder();
    }
    handleCloseConfirmDialog();
  };

  const handleOpenConfirmDialog = (boxIndex) => {
    setRowDeleteID(boxIndex);
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setError('')
    setOpenConfirmDialog(false);
    setRowDeleteID(null);
  };

  // const handleFilterInputs = (e) => {
  //   setGetDataForView([]);
  //   setFilterInputs({
  //     ...filterInputs,
  //     [e.target.name]: e.target.value,
  //   });
  // };

  async function getAllData() {
    // if (!validateFilters()) {
    //   return; // If validation fails, stop the request
    // }

    if (!validateDateInputs(filterInputs)) {
      return; // Stop the request if date validation fails
    }

    try {
      showLoading();
      const branchId = 0;
      const companyId = sessionStorage.getItem('CompanyId');
      let response;
      const draft = viewDraft ? 'Y' : 'N';
      if (filterInputs.type === 'courier') {
        response = await axios.get(
          `Transactions/Courier/GetCourierCollection/${moment(filterInputs.fromDate).format('YYYYMMDD')}/${moment(
            filterInputs.toDate
          ).format('YYYYMMDD')}/${filterInputs.status}/${companyId}/${branchId}/${sessionStorage.getItem('UserId')}/${draft}`
        );
      } else if (filterInputs.type === 'cargo') {
        response = await axios.get(
          `Transactions/Cargo/GetAllCargoCollection/${moment(filterInputs.fromDate).format('YYYYMMDD')}/${moment(
            filterInputs.toDate
          ).format('YYYYMMDD')}/${filterInputs.status}/${companyId}/${branchId}/${sessionStorage.getItem('UserId')}/${draft}`
        );
      } else {
        throw new Error('Invalid type selected. Please choose a valid type.');
      }

      setGetDataForView(response.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something went wrong! Try again.', 'error');
    }
    hideLoading();
  }

  useEffect(() => {
    getAllData();
    setTimeout(() => {
      if (sessionStorage.getItem('NewOrderPopupShown') === 'N') {
        setOpenShipmentPopup(true);
        sessionStorage.setItem('NewOrderPopupShown', 'Y');
      }
    }, 3000);
  }, []);

  // pagination
  const { totalRows, currentPage } = useMemo(() => {
    const totalRows = getDataForView.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const currentPage = Math.max(0, Math.min(page, totalPages - 1));
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, totalRows - page * rowsPerPage);

    return { totalRows, currentPage };
  }, [getDataForView, page, rowsPerPage]);

  const cancelOrder = async () => {
    try {
      let res;
      if (filterInputs.type === 'courier') {
        res = await axios.put(`/Transactions/Courier/CancelCourierOrder/${rowDeleteID}/${'Y'}/Y`, {
          headers: {
            Country: origin,
          },
        });
        sendMailForBookingCancelledByCustomer(sessionStorage.getItem('UserId'), rowDeleteID, 'CO');
      } else {
        res = await axios.put(`/Transactions/Cargo/CancelCargoOrder/${rowDeleteID}/${'Y'}/Y`, {
          headers: {
            Country: origin,
          },
        });
        sendMailForBookingCancelledByCustomer(sessionStorage.getItem('UserId'), rowDeleteID, 'CA');
      }
      InsertCustomerTimeLine()
      getAllData();
      openSnackBar('Order has been cancelled successfully');
    } catch (err) {
      console.log(err.message);
    }
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setDeleteRowID(null);
  };

  const deleteBooking = async () => {
    if (!deleteRowID) return;
    try {
      showLoading();
      if (filterInputs.type === 'courier') {
        await axios.delete(`/Transactions/Courier/DeleteCourier/${deleteRowID}`, {
          headers: { Country: origin },
        });
      } else {
        await axios.delete(`/Transactions/Cargo/DeleteCargo/${deleteRowID}`, {
          headers: { Country: origin },
        });
      }
      openSnackBar('Draft has been Deleted Successfully');
      getAllData();
    } catch (e) {
      openSnackBar('Something went wrong', 'error');
    }
    hideLoading();
    handleCloseDeleteDialog();
  };

  async function InsertCustomerTimeLine() {
    const newData = {
      Optype: 'New',
      customerId: sessionStorage.getItem('UserId'),
      companyId: sessionStorage.getItem('CompanyId'),
      branchId: 0,
      Order_ID: rowDeleteID,
      Order_Type: filterInputs.type === 'courier' ? 'CO' : 'CA',
      remarks: reason,
      followup: 'CCL',
      followupDate: new Date(),
      createdBy: sessionStorage.getItem('UserId'),
      createdOn: new Date(),
    };
    try {
      const response = await axios.post('Transactions/Customer_Timeline/InsertCustomerTimeline', newData);
    } catch (e) {
      console.log(e.response?.data || 'Something Went Wrong try Again !', 'error');
    }
  }

  const handleNewBookingClick = () => {
    setOpenShipmentPopup(true);
  };


  const handleProceed = (value) => {
    if (!value) {
      // setError('Please select a shipment type.');
      return;
    }
    // Route based on selected shipment type
    if (value === 'SCSL') {
      navigate(`/dashboard/manage/cargo_order_creation/${value}`);
    } else {
      navigate(`/dashboard/manage/courier_order_creation/${value}`);
    }
    setOpenShipmentPopup(false);
  };

  const [formErrors, setFormErrors] = useState({
    fromDate: '',
    toDate: '',
  });
  const [openTypeChangeDialog, setOpenTypeChangeDialog] = useState(false);
  const [pendingTypeValue, setPendingTypeValue] = useState(null);

  const validateFilters = () => {
    const errors = {};
    // Validate fromDate: should not be empty
    if (!filterInputs.fromDate) {
      errors.fromDate = 'From date is required';
    } else if (!moment(filterInputs.fromDate, 'YYYY-MM-DD', true).isValid()) {
      errors.fromDate = 'Invalid date format';
    }

    // Validate toDate: should not be empty and be a valid date
    if (!filterInputs.toDate) {
      errors.toDate = 'To date is required';
    } else if (!moment(filterInputs.toDate, 'YYYY-MM-DD', true).isValid()) {
      errors.toDate = 'Invalid date format';
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0; // Return true if no errors
  };

  const validateDateInputs = (inputs) => {
    const errors = {};

    // Validate fromDate
    if (!inputs.fromDate) {
      errors.fromDate = 'From date is required';
    } else if (!moment(inputs.fromDate, 'YYYY-MM-DD', true).isValid()) {
      errors.fromDate = 'Invalid date format';
    }

    // Validate toDate
    if (!inputs.toDate) {
      errors.toDate = 'To date is required';
    } else if (!moment(inputs.toDate, 'YYYY-MM-DD', true).isValid()) {
      errors.toDate = 'Invalid date format';
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleFilterInputs = (e) => {
    const { name, value } = e.target;
  
    // Early exit for 'type' field: open confirmation dialog
    if (name === 'type') {
      setPendingTypeValue(value);
      setOpenTypeChangeDialog(true);
      return;
    }
  
    // Default behavior for other fields
    setFilterInputs({ ...filterInputs, [name]: value });
  
    // Validate date fields
    if (name === 'fromDate' || name === 'toDate') {
      validateDateInputs({ ...filterInputs, [name]: value });
    }
  };

  const handleConfirmTypeChange = () => {
    if (pendingTypeValue === null) {
      setOpenTypeChangeDialog(false);
      return;
    }
    setFilterInputs({ ...filterInputs, type: pendingTypeValue });
    setGetDataForView([]);
    setPendingTypeValue(null);
    setOpenTypeChangeDialog(false);
  };

  const handleCancelTypeChange = () => {
    setPendingTypeValue(null);
    setOpenTypeChangeDialog(false);
  };

  async function sendMailForBookingCancelledByCustomer(cusID, OrderId, OrderType) {
    try {
      showLoading();
      const response = await axios.post('notifications/mails/sendMail', {
        MailScenario: 'BookingCancelledByCustomer',
        customerid: cusID,
        Type: OrderType,
        Order_Id: OrderId,
      });
    } catch (e) {
      openSnackBar('Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2 }} elevation={3}>
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
          <Typography
            variant="h5"
            p={0.5}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={12}
            pl={2}
            color="white"
            sx={{
              background: '#8ABFA3',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              Manage Booking
            </Typography>
          </Typography>
        </Grid>

        <Grid container spacing={2} p={1} my={0.5} rowSpacing={2} columnSpacing={1}>
          <Grid item md={3} xs={12}>
            {/* Status Filter */}
            <TextField
              fullWidth
              select
              label="Status"
              name="status"
              value={filterInputs.status}
              onChange={handleFilterInputs}
              variant="outlined"
              size="small"
              error={!!formErrors.status}
              helperText={formErrors.status}
            >
              {statusOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item md={3} xs={12}>
            {/* Status Filter */}
            <TextField
              fullWidth
              select
              label="Shipment Type"
              name="type"
              value={filterInputs.type}
              onChange={handleFilterInputs}
              variant="outlined"
              size="small"
              error={!!formErrors.type}
              helperText={formErrors.type}
            >
              <MenuItem key="courier" value="courier">
                Air-Cargo
              </MenuItem>
              {sessionStorage.getItem('Origin') === 'UK' && (
                <MenuItem key="cargo" value="cargo">
                  Sea-Cargo
                </MenuItem>
              )}
            </TextField>
          </Grid>

          <Grid item md={3} xs={12}>
            {/* From Date */}
            <TextField
              fullWidth
              label="From Date"
              type="date"
              name="fromDate"
              value={filterInputs.fromDate}
              onChange={handleFilterInputs}
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              size="small"
              error={!!formErrors.fromDate}
              helperText={formErrors.fromDate}
              inputProps={{ max: '9999-12-31' }}
            />
          </Grid>
        
          <Grid item md={3} xs={12}>
            {/* To Date */}
            <TextField
              fullWidth
              label="To Date"
              type="date"
              name="toDate"
              value={filterInputs.toDate}
              onChange={handleFilterInputs}
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              size="small"
              error={!!formErrors.toDate}
              helperText={formErrors.toDate}
              inputProps={{ max: '9999-12-31' }}
            />
          </Grid>
  <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
                          <Grid item md={2} xs={6} sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                {/* Draft Mode Switch */}
               <Box sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: 1,
              bgcolor: viewDraft ? '#eff6ff' : '#f8fafc',
              borderRadius: '8px',
              px: 0.75,
              py: 0.75,
              border: `1px solid ${viewDraft ? '#3b82f6' : '#e2e8f0'}`,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: viewDraft ? '#2563eb' : '#cbd5e1',
                boxShadow: viewDraft ? '0 0 0 2px rgba(59, 130, 246, 0.1)' : '0 0 0 2px rgba(203, 213, 225, 0.1)'
              }
            }}>
              {/* Custom Switch - Compact */}
              <Box 
                onClick={() => {
                  setViewDraft(!viewDraft)
                  setGetDataForView([])
                }}
                sx={{ 
                  position: 'relative',
                  width: 42,
                  height: 24,
                  borderRadius: '12px',
                  bgcolor: viewDraft ? '#3b82f6' : '#94a3b8',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  overflow: 'hidden',
                  flexShrink: 0,
                  '&:before': {
                    content: '""',
                    position: 'absolute',
                    top: 2,
                    left: viewDraft ? 20 : 2,
                    width: 20,
                    height: 20,
                    borderRadius: '50%',
                    bgcolor: 'white',
                    transition: 'all 0.2s ease',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.15)'
                  },
                  '&:after': {
                    content: '""',
                    position: 'absolute',
                    top: '50%',
                    left: viewDraft ? 6 : 24,
                    transform: 'translateY(-50%)',
                    width: 8,
                    height: 8,
                    backgroundImage: viewDraft ? 'radial-gradient(circle, #60a5fa 1px, transparent 1px)' : 'radial-gradient(circle, #cbd5e1 1px, transparent 1px)',
                    backgroundSize: '3px 3px',
                    opacity: 0.5,
                    transition: 'all 0.2s ease'
                  }
                }}
              />
              
              {/* Label with Icon - Compact */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, minWidth: 80 }}>
                <Box sx={{ 
                  width: 22,
                  height: 22,
                  borderRadius: '5px',
                  bgcolor: viewDraft ? '#dbeafe' : '#f1f5f9',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: `1px solid ${viewDraft ? '#bfdbfe' : '#e2e8f0'}`
                }}>
                  {viewDraft ? (
                     <span style={{ fontSize: 13, color: '#3b82f6' }}>📝</span>
                    // <LocalShippingIcon sx={{ fontSize: 13, color: '#3b82f6' }} />
                  ) : (
                    <span style={{ fontSize: 13, color: '#64748b' }}>📝</span>
                    // <LocalShippingIcon sx={{ fontSize: 13, color: '#64748b' }} />
                  )}
                </Box>
                <Box>
                  <Typography variant="body2" fontWeight="500" color={viewDraft ? '#1e40af' : '#475569'}>
                    {viewDraft ? 'Draft' : 'Draft'}
                  </Typography>
                </Box>
              </Box>
            </Box>
              </Grid>

          <Grid item md={1} xs={12}>
           
            {/* View Button */}
            <Button variant="contained" color="success" onClick={getAllData} fullWidth>
              View
            </Button>
          </Grid>
          <Grid item md={2} xs={12}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              endIcon={<LocalShippingIcon style={{ color: 'white' }} />}
              sx={{
                whiteSpace: 'nowrap',
                boxShadow: '0',
                position: 'relative',
                zIndex: 1,
                overflow: 'hidden',
              }}
              onClick={handleNewBookingClick}
              className="booking_button_newBooking"
            >
              New Booking
            </Button>
          </Grid>
          </Grid>
        </Grid>
        {getDataForView.length > 0 ? (
          <>
            <TableContainer component={Paper} elevation={2} sx={{ bgcolor: 'inherit', maxHeight: 600 }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center">S.No</StyledTableCell>
                    {filterInputs.type === 'courier' ? (
                      <StyledTableCell align="left">Courier Ref No</StyledTableCell>
                    ) : (
                      <StyledTableCell align="left">Cargo Ref No</StyledTableCell>
                    )}

                    {filterInputs.type === 'courier' ? (
                      <StyledTableCell align="left">Courier Date</StyledTableCell>
                    ) : (
                      <StyledTableCell align="left">&nbsp;Cargo Date&nbsp;</StyledTableCell>
                    )}
                    <StyledTableCell align="center">Customer</StyledTableCell>
                    <StyledTableCell align="left">From</StyledTableCell>
                    <StyledTableCell align="left">To</StyledTableCell>
                    <StyledTableCell align="center">Status</StyledTableCell>
                    <StyledTableCell align="center">No of Boxes</StyledTableCell>
                    <StyledTableCell align="center">Parcel Weight</StyledTableCell>
                    <StyledTableCell align="center" sx={{ position: 'sticky', right: 0, zIndex: 2 }}>
                      Actions
                    </StyledTableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {(rowsPerPage > 0
                    ? getDataForView.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    : getDataForView
                  ).map((data, i) => (
                    <>
                      <TableRow key={data.CUSTOMERID} hover>
                        <TableCell align="center">{page * rowsPerPage + (i + 1)}</TableCell>

                        {filterInputs.type === 'courier' ? (
                          <TableCell align="center">{data.COURIER_NO}
                          {data.IsDraft === 'Y' && (
                              <div style={{
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '3px 7px',
    borderRadius: '12px',
    backgroundColor: '#e3f2fd',
    border: '1px solid #90caf9'
  }}>
    <span style={{ fontSize: '14px', color: '#1976d2' }}>📝</span>
    <span style={{
      color: '#1565c0',
      fontWeight: '600',
      fontSize: '0.75rem'
    }}>
      Draft
    </span>
  </div>
)}
                          </TableCell>
                        ) : (
                          <TableCell align="center">{data.cargo_No}
                           {data.IsDraft === 'Y' && (
                              <div style={{
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '3px 7px',
    borderRadius: '12px',
    backgroundColor: '#e3f2fd',
    border: '1px solid #90caf9'
  }}>
    <span style={{ fontSize: '14px', color: '#1976d2' }}>📝</span>
    <span style={{
      color: '#1565c0',
      fontWeight: '600',
      fontSize: '0.75rem'
    }}>
      Draft
    </span>
  </div>
)}
                          </TableCell>
                        )}
                        {filterInputs.type === 'courier' ? (
                          <TableCell align="center">
                            {moment(data.courierDate, 'DD/MM/YYYY')?.format('DD-MM-YYYY') || '-'}
                          </TableCell>
                        ) : (
                          <TableCell align="center">
                            {moment(data.cargoDate, 'DD/MM/YYYY')?.format('DD-MM-YYYY') || '-'}
                          </TableCell>
                        )}
                        <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
                          {data.CUSTOMERNAME || '-'}
                        </TableCell>

                        <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
                          <Stack spacing={1} py={1}>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <PersonPinIcon fontSize="x-small" color="primary" />
                              <Typography variant="subtitle2" color="#243642" pr={1}>
                                {data.SENDER_NAME}
                              </Typography>{' '}
                            </Stack>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <LocationOn fontSize="x-small" color="error" />
                              <Typography variant="body2">
                                {data.SENDER_CITY}, {data.SENDER_STATE}, <br />
                                {data.SENDER_COUNTRY}, {data.SENDER_PINCODE}
                              </Typography>
                            </Stack>
                          </Stack>
                        </TableCell>
                        <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
                          <Stack spacing={1} py={1}>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <PersonPinIcon fontSize="x-small" color="primary" />
                              <Typography variant="subtitle2" color="#243642" pr={1}>
                                {data.RECEIVER_NAME}
                              </Typography>{' '}
                            </Stack>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <LocationOn fontSize="x-small" color="error" />
                              <Typography variant="body2">
                                {data.RECEIVER_CITY}, {data.RECEIVER_STATE}, <br />
                                {data.RECEIVER_COUNTRY}, {data.RECEIVER_PINCODE}
                              </Typography>
                            </Stack>
                          </Stack>
                        </TableCell>
                        <TableCell align="center">
                           <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                          {/* {data.OrderRaised === 'Y' ? (
                            <Chip label="Booking Confirmed" size="small" color="info" />
                          ) : data.STATUS === 'C' ? (
                            <Chip label="Cancelled" size="small" color="error" />
                          ) : data.SE_OrderCancelReq === 'R' ? (
                            <Chip label="Cancel Request" size="small" color="error" />
                          ) : data.STATUS === 'A' ? (
                            <Chip label="Approved" size="small" color="success" />
                          ) : (
                            <Chip label="Pending" size="small" color="warning" />
                          )} */}
                           {
                          data.singleOrderStatus === 'Cancelled' ? (
                            <Chip label={data.singleOrderStatus} size="small" color="error" />
                          ) : data.singleOrderStatus === 'Bill Raised' ||
                            data.singleOrderStatus === 'Payment Received' ||
                            data.singleOrderStatus === 'Booking Confirmed' ||
                            data.singleOrderStatus === 'Part Payment' ? (
                            <Chip label={data.singleOrderStatus} size="small" color="info" />
                          ) : data.singleOrderStatus === 'Approved' ? (
                            <Chip label={data.singleOrderStatus} size="small" color="success" />
                          ) : data.singleOrderStatus === 'Cancel Requested' ? (
                            <Chip label={data.singleOrderStatus} size="small" variant="outlined" color="error" />
                          ) : (
                            <Chip label={data.singleOrderStatus} size="small" color="warning" />
                          )}

                     {data.TrackNo && (
  <Button
    variant="contained"
    size="small"
    className='track_button'
    startIcon={<LocalShippingIcon />}
    onClick={() => {     
      window.open(`${axios.defaults.TRACKING_URL}${sessionStorage.getItem('country')}/${data.TrackNo}`, "_blank")
 }}
    sx={{
      '& .MuiButton-startIcon': {
        animation: 'moveTruck 2s ease-in-out infinite',
        '@keyframes moveTruck': {
          '0%, 100%': {
            transform: 'translateX(0)',
          },
          '50%': {
            transform: 'translateX(5px)',
          },
        },
      },
      '&:hover': {
        '& .MuiButton-startIcon': {
          animation: 'bounce 0.5s ease infinite',
          '@keyframes bounce': {
            '0%, 100%': {
              transform: 'translateY(0)',
            },
            '50%': {
              transform: 'translateY(-2px)',
            },
          },
        },
      },
      
    }}
  >
    Track
  </Button>
)}
                                </div>
                        </TableCell>
                        <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                          {data.NO_OF_BOXES || '-'}
                        </TableCell>
                        <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                          {data.ParcelWeight || '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ position: 'sticky', right: 0, bgcolor: '#F9FAFB', zIndex: 1, whiteSpace: 'nowrap' }}
                        >
                          <Stack
                            direction="column"
                            spacing={1}
                            justifyContent="center"
                            alignItems="center"
                            sx={{ width: '100%' }}
                          >
                            <Chip
                              icon={
                                data.STATUS === 'A' ? (
                                  <RemoveRedEyeIcon />
                                ) : data.STATUS === 'C' || data.SE_OrderCancelReq === 'R' ? (
                                  <RemoveRedEyeIcon />
                                ) : (
                                  <EditIcon />
                                )
                              }
                              size="small"
                              label={
                                data.STATUS === 'A'
                                  ? 'Preview'
                                  : data.STATUS === 'C' || data.SE_OrderCancelReq === 'R'
                                    ? 'Preview'
                                    :  data.IsDraft === 'Y' ? 'Continue' : 'Edit'
                              }
                              color={data.STATUS === 'C' || data.SE_OrderCancelReq === 'R' ? 'error' : 'primary'}
                              variant={
                                data.STATUS === 'A'
                                  ? 'outlined'
                                  : data.STATUS === 'C' || data.SE_OrderCancelReq === 'R'
                                    ? 'outlined'
                                    : 'outlined'
                              }
                              sx={{ width: '100%' }}
                              onClick={() => {
                                if (filterInputs.type === 'courier') {
                                  if (data.STATUS === 'C' || data.SE_OrderCancelReq === 'R') {
                                    navigate(`/dashboard/manage/courier_order_creation/Edit/${data.courier_Id}/A`);
                                  } else {
                                    navigate(
                                      `/dashboard/manage/courier_order_creation/Edit/${data.courier_Id}/${data.STATUS}`
                                    );
                                  }
                                } else {
                                  if (data.STATUS === 'C' || data.SE_OrderCancelReq === 'R') {
                                    navigate(`/dashboard/manage/cargo_order_creation/Edit/${data.cargo_Id}/A`);
                                  } else {
                                    navigate(
                                      `/dashboard/manage/cargo_order_creation/Edit/${data.cargo_Id}/${data.STATUS}`
                                    );
                                  }
                                }
                              }}
                            />
                            {data.IsDraft === 'Y' ? (
                             <Chip
                                icon={<DeleteForeverIcon />}
                                label="Delete"
                                color="error"
                                size="small"
                                sx={{ width: '100%' }}
                                onClick={() => {
                                  if (filterInputs.type === 'courier'){
                                    setDeleteRowID(data.courier_Id);
                                  }else{
                                    setDeleteRowID(data.cargo_Id);
                                  }
                                  setOpenDeleteDialog(true);
                                }}
                              />
                            ) :
                            (data.SE_OrderCancelReq === 'N' && data.STATUS === 'P' && (
                              <Chip
                                icon={<CancelIcon />}
                                label="Cancel"
                                color="error"
                                size="small"
                                sx={{ width: '100%' }}
                                onClick={() => {
                                  if (filterInputs.type === 'courier') {
                                    if (data.STATUS === 'C') {
                                      alert('Order Cancelled Cannot Edit or Delete !', 'waring');
                                    } else if (data.STATUS === 'P') {
                                      handleOpenConfirmDialog(data.courier_Id);
                                    } else {
                                      alert('Order Approved Cannot Edit or Delete !', 'waring');
                                    }
                                  } else {
                                    if (data.STATUS === 'C') {
                                      alert('Order Cancelled Cannot Edit or Delete !', 'waring');
                                    } else if (data.STATUS === 'P') {
                                      handleOpenConfirmDialog(data.cargo_Id);
                                    } else {
                                      alert('Order Approved Cannot Edit or Delete !', 'waring');
                                    }
                                  }
                                }}
                              />
                            ))}
                          </Stack>
                        </TableCell>
                      </TableRow>
                    </>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={totalRows}
              rowsPerPage={rowsPerPage}
              page={currentPage}
              onPageChange={(event, newPage) => setPage(newPage)}
              onRowsPerPageChange={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
              }}
              mt={2}
            />
          </>
        ) : (
          <NoResultsFound />
        )}

        {/* Confirmation Dialog for Deletion */}
        {/* <Dialog open={openConfirmDialog} onClose={handleCloseConfirmDialog}>
          <DialogTitle>Confirm Cancel</DialogTitle>
          <DialogContent>
            <Typography>Are you sure you want to Cancel this Order?</Typography>
            <TextField
              fullWidth
              size="small"
              label="Reason for Cancel"
              type="text"
              multiline
              rows={5}
              name="remarks"
              value={''}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseConfirmDialog} color="warning">
              Close
            </Button>
            <Button onClick={handleConfirmDelete} color="error">
              Yes
            </Button>
          </DialogActions>
        </Dialog> */}

        <Dialog
          open={openConfirmDialog}
          PaperProps={{
            style: {
              borderRadius: '12px',
              padding: '10px',
            },
          }}
        >
          <DialogTitle sx={{ textAlign: 'center' }}>Confirm Booking Cancellation</DialogTitle>
          <DialogContent
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
            }}
          >
            <Typography
              variant="body1"
              sx={{
                textAlign: 'center',
                color: '#555',
              }}
            >
              Before we cancel your shipment, could you please provide a reason?
            </Typography>
            <TextField
              fullWidth
              size="small"
              label="Reason for Cancellation"
              multiline
              rows={4}
              placeholder="Please provide a reason for cancellation..."
              value={reason}
              onChange={handleReasonChange}
              InputProps={{
                style: {
                  borderRadius: '8px',
                },
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: '#ccc',
                  },
                  '&:hover fieldset': {
                    borderColor: '#aaa',
                  },
                },
              }}
              error={!!error}
              helperText={error}
            />
          </DialogContent>
          <DialogActions
            sx={{
              justifyContent: 'center',
              gap: '16px',
              padding: '16px',
            }}
          >
            <Button onClick={handleCloseConfirmDialog} variant="contained" color="warning" >
              No, Keep Order
            </Button>
            <Button onClick={handleConfirmDelete} variant="contained" color="error" >
              Yes, Cancel Order
            </Button>
          </DialogActions>
        </Dialog>

        {/* Confirm dialog for changing shipment type which clears the grid */}
        <Dialog open={openTypeChangeDialog} onClose={handleCancelTypeChange} maxWidth="xs" fullWidth>
          <DialogTitle sx={{ textAlign: 'center' }}>Change Shipment Type</DialogTitle>
          <DialogContent>
            <Typography variant="body1" sx={{ textAlign: 'center', color: '#555' }}>
              Changing the shipment type will clear the current grid. Do you want to continue?
            </Typography>
          </DialogContent>
          <DialogActions sx={{ justifyContent: 'center', gap: 2, padding: 2 }}>
            <Button variant="contained" onClick={handleCancelTypeChange} color="primary">
              No, Keep Grid
            </Button>
            <Button variant="contained" onClick={handleConfirmTypeChange} color="error">
              Yes, Clear and Continue
            </Button>
          </DialogActions>
        </Dialog>

        {/* Shipment Popup */}
        {/* Delete Confirmation Dialog */}
        <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog} fullWidth maxWidth="xs">
          <DialogTitle sx={{ textAlign: 'center' }}>Are you sure you want to delete?</DialogTitle>
           <DialogContent>
                              <Typography>Are you sure you want to delete this order? This action cannot be undone.</Typography>
                            </DialogContent>
          <DialogActions sx={{ justifyContent: 'center', gap: 2, padding: 2 }}>
            <Button variant="contained" onClick={handleCloseDeleteDialog} color="primary">
              Cancel
            </Button>
            <Button variant="contained" onClick={deleteBooking} color="error">
              Delete
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openShipmentPopup}
          onClose={() => setOpenShipmentPopup(false)}
          maxWidth="sm"
          // fullWidth
          PaperProps={{
            sx: {
              backgroundColor: 'transparent',
              boxShadow: 'none',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            },
          }}
        >
          <DialogContent>
            <Stack>
              <Typography variant="h6" color="white" align="center" mb={3}>
                Choose and Start Your Booking Now
              </Typography>
              <Grid container spacing={2}>
                {shipmentTypes.map((type) => (
                  <Grid item xs={12} sm={6} md={origin === 'IN' || origin === 'SL' ? 12 : 4} key={type.value}>
                    <Card
                      onClick={() => handleProceed(type.value)}
                      sx={{
                        position: 'relative',
                        overflow: 'hidden',
                        boxShadow:
                          selectedShipment === type.value
                            ? 'rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset'
                            : '0 4px 8px rgba(0, 0, 0, 0.1)',
                        borderRadius: 2,
                        scale: selectedShipment === type.value ? 1.1 : 1,
                        border: selectedShipment === type.value ? '2px solid #6A9C89' : '1px solid #ddd',
                      }}
                      className="card_hover_effect"
                    >
                      {/* Background Image */}
                      <Box
                        component="img"
                        src={type.image}
                        alt={type.label}
                        sx={{
                          width: '100%',
                          height: 200,
                          objectFit: 'cover',
                        }}
                      />
                      {/* Circular Icon Overlay */}
                      <Box
                        sx={{
                          position: 'absolute',
                          top: 168,
                          left: '50%',
                          transform: 'translateX(-50%)',
                          width: 70,
                          height: 70,
                          borderRadius: '50%',
                          backgroundColor: '#fff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                        }}
                      >
                        <Box
                          component="img"
                          src={type.icon}
                          alt={`${type.label} Icon`}
                          sx={{ width: 40, height: 40, objectFit: 'cover' }}
                        />
                      </Box>
                      {/* Content */}
                      <CardContent sx={{ textAlign: 'center', mt: 3 }}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#0D7C66' }}>
                          {type.label}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
              {/* <Stack justifyContent="center" alignItems={'center'} direction={'row'} spacing={2} my={2}>
                <Button onClick={() => setOpenShipmentPopup(false)} color="warning" variant="contained" size="small">
                  Close
                </Button>
              </Stack> */}
              {error && (
                <Typography variant="caption" color="error" margin="4px 0 0">
                  {error}
                </Typography>
              )}
            </Stack>
          </DialogContent>
        </Dialog>
      </Container>
    </>
  );
};

export default ManageBooking;
